module.exports = __webpack_public_path__ + "images/transparent-pixel.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/transparent-pixel.gif
// module id = 1456
// module chunks = 0